/**
 * 登入 / 2FA / 目前使用者。
 *
 * 注意與 `../auth` 的分工：那支管 token 在 localStorage 的存取與 logout 廣播，
 * 這支只負責打端點。
 */

import { apiFetch } from './core';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  session_id: string;
  two_factor_required: boolean;
  access_token?: string;
}

export interface TotpRequest {
  session_id: string;
  totp_code: string;
}

export interface AuthUser {
  user_id: string;
  email: string;
  display_name?: string;
  permissions: string[];
  requires_2fa: boolean;
}

export function login(payload: LoginRequest): Promise<LoginResponse> {
  return apiFetch<LoginResponse>('/auth/login', {
    method: 'POST',
    body: payload,
    skipAuth: true,
  });
}

export function loginTotp(payload: TotpRequest): Promise<{ access_token: string }> {
  return apiFetch<{ access_token: string }>('/auth/login/totp', {
    method: 'POST',
    body: payload,
    skipAuth: true,
  });
}

export function getMe(): Promise<AuthUser> {
  return apiFetch<AuthUser>('/auth/me', { method: 'GET' });
}

export function logout(): Promise<void> {
  return apiFetch<void>('/auth/logout', { method: 'POST' });
}
